<template>
  <div style="position: relative;">
    <div class="row mx-3">
      <div class="col-12 p-0">
        <div class="row">
          <div
            class="col-md-12  mt-4 p-3 card-container"
            :class="[statusClass, containerBgWhite ? 'bg-white' : '']"
          >
            <div class="row d-flex justify-content-between">
              <div
                v-if="status"
                class="border-right pt-2"
                :class="[
                  getStatusClasses,
                  {
                    'd-flex flex-column justify-content-between':
                      $slots['extra'],
                    'align-items-center d-flex':
                      !$slots['statusInfo'] && !$slots['extra'],
                  },
                ]"
              >
                <div
                  v-if="showExpandedArrowIcon && false"
                  class="arrow-icon-container"
                >
                  <div
                    :class="getBgIcon(extraExpanded)"
                    class="dot text-center cursor-pointer"
                    @click="extraExpanded = !extraExpanded"
                  >
                    <i class="title-icon" :class="getIcon(extraExpanded)" />
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <p
                      class="text-center py-2 px-4 status-pill"
                      :class="[statusClass, { 'mb-0': $slots['extra'] }]"
                    >
                      {{ status }}
                    </p>
                  </div>
                </div>
                <slot name="statusInfo" />
                <div v-if="$slots['extra']">
                  <div
                    :class="getBgIcon(extraExpanded)"
                    class="dot text-center cursor-pointer"
                    @click="extraExpanded = !extraExpanded"
                  >
                    <i class="title-icon" :class="getIcon(extraExpanded)" />
                  </div>
                </div>
                <div v-if="$slots['dynamicExtra']">
                  <div class="green dot text-center cursor-pointer">
                    <i class="fas fa-chevron-down title-icon" />
                  </div>
                </div>
              </div>
              <div class="col-md-10" :class="{ 'col-md-12': !status }">
                <div class="row w-100">
                  <div
                    class="col-md-10"
                    :class="{
                      'col-md-10 col-sm-12': $slots['actions'],
                      'col-md-10 col-sm-12': !$slots['actions'] || !status,
                      'col-md-12 col-sm-12': !status && !$slots['actions'],
                    }"
                  >
                    <slot name="body" />
                  </div>
                  <div
                    v-if="$slots['actions']"
                    class="col-md-2 col-sm-12 pt-2 text-right"
                  >
                    <slot name="actions" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <slot v-if="extraExpanded" name="extra" />
          <slot name="dynamicExtra" />
        </div>
      </div>
    </div>
    <div v-if="extraExpandedSection" class="card-expanded-container">
      <div class="card-body">
        <slot name="extraExpandedSection" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RowCardItemCard',
  meta: {
    description: 'Componente común estados de tarjeta de artículo.',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  props: {
    status: {
      type: String,
      default: () => null,
      meta: {
        description: 'Establece el estado del componente',
        example: 'Texto requerido',
      },
    },
    statusClass: {
      type: String,
      required: true,
      meta: {
        description: 'Clasifica el estado por color',
        example: 'green',
      },
    },
    containerBgWhite: {
      type: Boolean,
      required: false,
      default: () => false,
      meta: {
        description: 'Cambia background de container en blanco o gris',
        example: 'true',
      },
    },
    centerStatus: {
      type: Boolean,
      default: () => false,
      meta: {
        description: 'Permite posicionamiento al centro',
        example: 'true',
      },
    },
    statusColumns: {
      type: Number,
      default: () => 2,
      meta: {
        description: 'Establece el número de columnas',
        example: '6',
      },
    },
    extraExpandedSection: {
      type: Boolean,
      default: () => false,
      meta: {
        description: 'Permite expandir la sección extra',
        example: 'true',
      },
    },
    showExpandedArrowIcon: {
      type: Boolean,
      default: () => false,
      meta: {
        description: 'Permite mostrar el icono de expansión',
        example: 'true',
      },
    },
  },
  data() {
    return {
      extraExpanded: false,
      dynamicExtraExpanded: true,
    };
  },
  methods: {
    getIcon(expanded) {
      return expanded ? 'fas fa-chevron-down' : 'fas fa-chevron-right';
    },
    getBgIcon(expanded) {
      return expanded ? 'green' : 'gray';
    },
  },
  computed: {
    getStatusClasses() {
      let classes = '';
      if (this.centerStatus) {
        classes += 'd-flex align-items-center justify-content-center pl-0';
      }
      classes += ' col-md-' + this.statusColumns;
      return classes;
    },
  },
};
</script>

<style scoped>
.card-expanded-container {
  background-color: #f7f7f7;
  /* padding-top: 1rem; */
}
.status-pill {
  width: fit-content;
  border-radius: 26px;
  opacity: 1;
  text-align: center;
  font: Bold 16px/21px Lato;
  letter-spacing: 0;
  color: #11291b;
}
.status-pill.brown {
  background-color: #d5b89a;
}
.status-pill.yellow {
  background-color: #f8ea80;
}
.status-pill.pink {
  background-color: #fcc9c8;
}
.status-pill.green {
  background-color: #a4e5b2;
}
.status-pill.violet {
  background-color: #ddb3d7;
}
.status-pill.gray {
  background-color: #e8e8e8;
}
.status-pill.orange {
  background-color: #f8ca80;
}
.card-container {
  background-color: #f7f7f7;
  border-radius: 5px;
  border-left-style: solid;
  border-width: 4px;
}
.card-container.bg-white {
  background-color: white;
}
.card-container.gray {
  border-color: #e8e8e8;
}
.card-container.brown {
  border-color: #d5b89a;
}
.card-container.yellow {
  border-color: #f8ea80;
}
.card-container.pink {
  border-color: #fcc9c8;
}
.card-container.green {
  border-color: #a4e5b2;
}
.card-container.violet {
  border-color: #ddb3d7;
}
.card-container.orange {
  border-color: #f8ca80;
}
.btn-dropdown-actions {
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
}
.dropdown-menu {
  margin-top: 1rem;
}

.dropdown-item {
  font: Regular 16px/19px Lato;
}

.dropdown-item i {
  margin-right: 1rem;
}

.drop-item {
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 0.9375rem;
  color: #11291b;
  text-align: inherit;
  white-space: nowrap;
  display: block;
  padding: 0.29rem 1.5rem;
  clear: both;
}
.dot {
  box-shadow: 0px 3px 6px #00000029;
  margin: 2px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border-style: solid;
  border-width: 3px;
  border-color: #fff;
  display: inline-block;
}
.dot.green {
  background-color: #2db782;
}
.dot.gray {
  background-color: #3f5b60;
}
.title-icon {
  font-size: 1rem;
  color: #fff;
  margin: 6px;
}
.arrow-icon-container {
  position: absolute;
  z-index: 1;
  top: 23px;
  left: -14px;
  background: red;
  height: 92%;
}
</style>
